import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'yearformat' })
export class YearFormatterPipe implements PipeTransform{

    transform(date: string) {
        var splitted = date.split("-", 3); 
        return splitted[2];
    }
}
